import request from "../libs/request";

const baseUrl = "center/incommodity/atg";

export type AtgSearchRequest = {
  atgBuildingId: string;
  workerName: string;
};

export type AtgWorker = {
  workerName: string;
  job?: string;
};

export const searchAtgWorker = (params: AtgSearchRequest) =>
  request.get<AtgWorker[]>(`${baseUrl}/worker`, { params });

export type AtgResourceSearchRequest = {
  atgBuildingId: string;
  resourceName: string;
};

export type AtgResource = {
  materialName: string;
  standardName: string;
  centerCode: string;
  materialCode: string;
  inventory: string;
  centerName: string;
  storageCode: string;
  storageName: string;
  communicationResultMessage: string | null;
  communicationResult: string | null;
  useQuantity?: string;
};

export const searchAtgResource = (params: AtgResourceSearchRequest) =>
  request.get<AtgResource[]>(`${baseUrl}/resource`, { params });
